import React, { FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/actions/user.actions";
import DashboardLayout from "components/DashboardLayout/DashboardLayout";
import { getUsersData, getCount } from "redux/selectors/user.selector";
import DashboardView from "views/DashboardView/DashboardView";
import "./i18n";
import i18next from "i18next";
import SuccessAlert from "components/SuccessAlert/SuccessAlert";
import { hideSuccessNotification } from "redux/actions/success.actions";
import getSuccessSelector, {
  getSuccessText,
} from "redux/selectors/success.selector";
import { Data } from "components/DashboardTable/types";
import { SUCCESS_TEXT } from "common/constants/successMesages.constants";

const UserDashboardContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const usersData = useSelector(getUsersData());
  const [tableKeys, setTableKeys] = useState<string[]>([]);
  const [actualPage, setActualPage] = useState(0);
  const getUserCount = useSelector(getCount());
  const successSelector = useSelector(getSuccessSelector());
  const successText = useSelector(getSuccessText());

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let query = params.get("q");
    if (!query) {
      query = "";
    }
    dispatch(actions.onInitializeUserDashboard(query, actualPage));
  }, [dispatch, actualPage]);

  useEffect(() => {
    if (usersData.length) {
      const keys = Object.keys(usersData[0]);
      setTableKeys(keys);
    }
  }, [usersData]);

  setTimeout(() => {
    if (successSelector) {
      dispatch(hideSuccessNotification());
    }
  }, 2500);

  const search = (query: string) => {
    dispatch(actions.onInitializeUserDashboard(query, actualPage));
  };

  const onDelete = (ids: string[]) => {
    dispatch(actions.onDeleteUsers(ids));
  };

  const onCreateUser = () => {
    dispatch(actions.onRedirectToCreateUserForm());
  };

  const editUser = (userId: string) => {
    dispatch(actions.onRedirectToEditUserForm(userId));
  };

  return (
    <DashboardLayout>
      {successSelector && successText === SUCCESS_TEXT.created && (
        <SuccessAlert message={i18next.t("USER_DASHBOARD:CREATED")} />
      )}
      {successSelector && successText === SUCCESS_TEXT.deleted && (
        <SuccessAlert message={i18next.t("USER_DASHBOARD:DELETED")} />
      )}
      <DashboardView
        search={search}
        data={usersData as Data[]}
        keys={tableKeys}
        title="Users"
        onClickAdd={onCreateUser}
        onDelete={onDelete}
        onEdit={editUser}
        actualPage={actualPage}
        setPage={setActualPage}
        count={getUserCount}
      />
    </DashboardLayout>
  );
};

export default UserDashboardContainer;
